import { lazy } from 'react';
import type { RouteProps } from 'react-router-dom';

const IndustryCasesLayout = lazy(() => import('.'));
const IndustryInformationMenu = lazy(() => import('./menu'));
const IndustryInformationList = lazy(() => import('./menu/list'));
const IndustryCasesDetail = lazy(() => import('./detail'));

export const routeConfig: (RouteProps & { subChildren?: RouteProps[] })[] = [
  {
    path: '/industry-cases',
    element: <IndustryCasesLayout />,
  },
  {
    path: '/industry-cases/menu',
    element: <IndustryInformationMenu />,
    subChildren: [
      { path: '/industry-cases/menu/list', element: <IndustryInformationList /> },
    ],
  },
  {
    path: '/industry-cases/detail/:id',
    element: <IndustryCasesDetail />,
  },
];
